export default __webpack_public_path__ + "static/2121-3b7084b3188ebb281a2ae561ecd7684e.gif";